import styled, { css } from 'styled-components'

export const Container = styled.div`
    height: 99.8%;
    margin: auto 0;
    padding: 0.5rem 1rem;
    border-radius: 0 1rem 1rem 0;
    box-shadow: 1.5px 1.5px 2px 1px rgba(0, 0, 0, 0.2);
    background: #4A007A;
    overflow: auto;
    z-index: 99;

    &::-webkit-scrollbar {
        display: none;
    }

    scrollbar-width: none;

    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;


    .logOut{
        margin: 1rem 0;
        color: #FFF6FF;
        transition: all 0.2s ease;

        display: flex;
        align-items: center;

        &:hover{
            color: #FFACFF;
        }

        p{
            font-size: ${props => props.openSideBar ? '1rem' : 0};
            transition: all 0.2s ease;
        }

        svg{
            font-size: 1.5rem;
            margin-right: ${props => props.openSideBar ? '1rem' : 0};
            transition: all 0.2s ease;
        }

        @media (min-width: 960px){
            cursor: pointer;
        }

    }

`

export const SideBarHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
        transition: height 0.2s;
        height: ${props => props.openSideBar ? '30px' : 0};
    }
`

export const HamburguerButton = styled.div`
    width: 30px;
    min-height: 32px;
    border-radius: 0.2rem;
    transition: all 0.2s;
    transform: ${props => props.openSideBar ? 'translateX(-4px)' : 'translateX(0)'};

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;

    div{
        min-height: 4px;
        width: 99%;
        border-radius: 0.5rem;
        background: #FFF6FF;
        transition: all 0.2s;
    }

    ${props => props.openSideBar && css`

        .barOne{
            transform: rotate(-45deg) translateY(8px);
        }

        .barTwo{
           display: none;
        }

        .barThree{
            transform: rotate(45deg) translateY(-8px) ;
        }
    `}

    @media (min-width: 960px){
        cursor: pointer;
    }
`


export const BusinessButton = styled.div`
    padding: 1rem 0;
    margin: 0.3rem 0;
    transition: all 0.2s;
    color: #FFF6FF;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover{
        color: #FFACFF;
    }

    svg{
        font-size: 1.5rem;
        margin-right: ${props => props.openSideBar ? '1rem' : 0};
        transition: all 0.2s;
    }

    p{
        flex: ${props => props.openSideBar ? 'auto' : 'none'};
        font-size: ${props => props.openSideBar ? '1rem' : 0};
        transition: all 0.2s;
    }

    @media (min-width: 960px){
        cursor: pointer;
    }
`

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex: auto;
    margin-bottom: 1.5rem;



    div{
        padding: 1rem 0;
        margin: 0.3rem 0.1rem;
        transition: all 0.2s;
        color: #FFF6FF;

        display: flex;

        flex-direction: column;

        &:hover{
            color: #FFACFF;
        }

        svg{
            font-size: 1.5rem;
            margin-right: ${props => props.openSideBar ? '1rem' : 0};
            transition: all 0.2s;
        }

        p{
            flex: ${props => props.openSideBar ? 'auto' : 'none'};
            font-size: ${props => props.openSideBar ? '1rem' : 0};
            transition: all 0.2s;
        }

            span{
                display: flex;
                align-items: center;
            }

            svg{
                transition: all 0.2s ease;
            }

            ul{
                list-style: none;
                transition: all 0.1s ease;
                display: flex;
                flex-direction: column;
                padding-top: 20px;

                li{
                    padding: 6px 6px 14px 50px;
                    margin-top: -10px;
                }
            }

        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`

export const PeriodButton = styled.div`
    padding: 0 0 2rem 0;
    margin: 0.3rem 0;
    transition: all 0.2s;
    color: #FFF6FF;

    border-bottom: 1px solid #A139CD;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover{
        color: #FFACFF;
    }

    svg{
        font-size: 1.5rem;
        margin-right: ${props => props.openSideBar ? '1rem' : 0};
        transition: all 0.2s;
    }

    p{
        flex: ${props => props.openSideBar ? 'auto' : 'none'};
        font-size: ${props => props.openSideBar ? '1rem' : 0};
        transition: all 0.2s;
    }

    @media (min-width: 960px){
        cursor: pointer;
    }
`